import SentrySingleton from "@/singletons/sentry-singleton"

export default class RenderingPathService {
    formatConfig(config: string | null | undefined, optionList: any): string | null {
        try {
            if (config) {
                return config!
            }
            const obj = optionList.find((x: any) => x.default && x.default === true)
            if (obj) {
                return obj.id
            }
            return null
        }
        catch (err) {
            SentrySingleton.instance.captureException(err)
            return null
        }

    }

}